// Landing widgets
export { HeroSection } from './landing/HeroSection';
export { Footer } from './landing/Footer';

// Search widgets
export { SearchPanel } from './SearchPanel';
export type { SearchPanelProps } from './SearchPanel';

// Map widgets
export { MapWithFilter } from './map/MapWithFilter';
export type { MapWithFilterProps, Marker } from './map/MapWithFilter';

// Section widgets
export { ContractorsSection } from './sections/ContractorsSection';
export { ClientOrdersSection } from './sections/ClientOrdersSection';
export type { ContractorsSectionProps } from './sections/ContractorsSection';
export type { ClientOrdersSectionProps } from './sections/ClientOrdersSection';

// Notification widgets
export { NotificationBell } from './notifications';
